import type { UserRole } from "@carry/shared";

const ROLE_LABEL: Record<UserRole, string> = {
  admin: "管理者",
  office_staff: "事務所",
  driver: "ドライバー",
};

/**
 * ユーザーロールの画面表示名.
 * Record で全ロールを網羅するため、UserRole にロールが増えると型エラーで検出できる
 * (三項演算子の連鎖だと新ロールが既定値に落ちて誤表示になる)。
 */
export function roleLabel(role: UserRole): string {
  return ROLE_LABEL[role];
}
